export class VesselAnnouncementDocument {
}
